import React, { useState } from "react";
import { getToken, URL } from "../../utils";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

export default function ProfessionalsAddFacture() {
  // Définir les états pour chaque champ de formulaire
  const [nom, setNom] = useState("");
  const [secteur, setSecteur] = useState("");
  const [adresse, setAdresse] = useState("");
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [registre, setRegistre] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  const token = getToken();

  // Gestionnaire de soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setValidationErrors({});

    const formData = {
      nom_entreprise: nom,
      secteur_activite: secteur,
      registre_commerce: registre,
      adresse: adresse,
      contact: contact,
      email: email,
    };

    try {
      await axios.post(URL + "Clients/create-client-professionnel", formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      navigate("/sales/add");
      toast.succes("Formulaire soumis avec succès:");
    } catch (error) {
      if (error.response) {
        if (error.response.data) {
          setValidationErrors(error.response.data);
          setError("Erreurs de validation:");
        } else {
          setError("Erreur lors de l'envoi du formulaire");
        }
      } else {
        setError(error.message);
      }
    }
  };

  if (error) {
    toast.error(error);
  }

  return (
    <div className="p-4 w-[min(600px,90%)] mx-auto mt-4 bg-white shadow-md rounded-md">
      <ToastContainer />
      <div className="flex gap-4 p-4 pb-0">
        <div className="p-3 bg-amber-200 rounded-full text-amber-600 grid justify-center items-center">
          <svg
            className="w-8 h-8"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M16 12h4m-2 2v-4M4 18v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Zm8-10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            />
          </svg>
        </div>
        <div className="">
          <h1 className="text-lg font-semibold">Ajouter un professionnel</h1>
          <p className="text-sm text-gray-500">
            Ajoutez un professionnel à la liste des clients
          </p>
        </div>
      </div>
      <form className="p-4" onSubmit={handleSubmit}>
        {error && <div className="mb-4 text-red-500">{error}</div>}
        {validationErrors &&
          // Boucle pour tous les messages d'erreur
          Object.keys(validationErrors).map((key) => (
            <div key={key} className="mb-4 text-red-500">
              {validationErrors[key]}
            </div>
          ))}
        <div className="mb-4">
          <label
            htmlFor="nom"
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            Nom de l'entreprise
          </label>
          <input
            type="text"
            id="nom"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5"
            placeholder="Nom de l'entreprise"
            value={nom}
            onChange={(e) => setNom(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
          <label
            htmlFor="registre"
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            Numero de registre de commerce
          </label>
          <input
            type="number"
            id="registre"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5"
            placeholder="Numero de registre de commerce"
            value={registre}
            onChange={(e) => setRegistre(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
          <label
            htmlFor="secteur"
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            Secteur d'activité
          </label>
          <select
            id="secteur"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5"
            value={secteur}
            onChange={(e) => setSecteur(e.target.value)}
            required
          >
            <option value="">---Choisir un secteur---</option>
            <option value="shop">Boutique</option>
            <option value="bar">Bar</option>
            <option value="restaurant">Restaurant</option>
            <option value="hôtel">Hôtel</option>
            <option value="Company">Compagnie</option>
            <option value="night_etablissement">Établissement de nuit</option>
          </select>
        </div>
        <div className="mb-4 flex gap-4">
          <div className="flex-grow">
            <label
              htmlFor="adresse"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Adresse
            </label>
            <input
              type="text"
              id="adresse"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5"
              placeholder="Adresse"
              value={adresse}
              onChange={(e) => setAdresse(e.target.value)}
              required
            />
          </div>
          <div className="flex-grow">
            <label
              htmlFor="contact"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Contact
            </label>
            <input
              type="tel"
              id="contact"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5"
              placeholder="Contact"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="mb-4">
          <label
            htmlFor="email"
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            Email
          </label>
          <input
            type="email"
            id="email"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="grid grid-cols-2 items-center gap-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="hover:text-white border border-gray-800 bg-gray-200 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5"
          >
            Annuler
          </button>
          <button
            type="submit"
            className="text-white bg-amber-600 hover:bg-amber-700 focus:ring-4 focus:outline-none focus:ring-amber-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
          >
            Ajouter
          </button>
        </div>
      </form>
    </div>
  );
}
